module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Histórico")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Geschichte")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historic")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historia")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.registros, 'labelPtBr')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.registros, 'labelDe')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.registros, 'labelEn')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.registros, 'labelEs')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7926e6a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Manutencao.vue
// module id = 421
// module chunks = 1